import { render } from "./Commands.vue?vue&type=template&id=37d09252"
import script from "./Commands.vue?vue&type=script&lang=js"
export * from "./Commands.vue?vue&type=script&lang=js"

import "./Commands.vue?vue&type=style&index=0&id=37d09252&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__